<template>
  <div>
    <editor-content
      ref="content"
      class="border tiptap-v2 overflow-auto h-[292px] p-2 mb-2"
      :editor="editor"
    />

    <editor-menu-bar
      v-slot="{ commands, isActive, getMarkAttrs }"
      :editor="editor"
      @hide="hideLinkMenu"
    >
      <div>
        <b-btn-group>
          <b-btn
            :class="{ 'is-active': isActive.bold() }"
            variant="white"
            class="h-[28px] w-[28px] p-0"
            @click="commands.bold"
          >
            <svg
              fill="none"
              height="14"
              viewBox="0 0 13 14"
              width="13"
              xmlns="http://www.w3.org/2000/svg"
              class="scale-75"
            >
              <path
                :fill="isActive.bold() ? '#000' : '#AEB1B4'"
                d="M11.9766 7.47738C11.4408 6.87067 10.6462 6.44901 9.59244 6.21208C10.3309 5.88273 10.7774 5.66032 10.9321 5.54481C11.3072 5.27323 11.5899 4.96983 11.7801 4.63476C11.9706 4.29958 12.0658 3.92982 12.0658 3.52543C12.0658 3.14991 12.0034 2.79748 11.8783 2.46813C11.7533 2.13871 11.5598 1.83829 11.2979 1.56676C11.0301 1.29529 10.7264 1.07561 10.3871 0.908051C10.0716 0.757884 9.78582 0.645235 9.52983 0.570136C8.91673 0.41411 8.3482 0.336097 7.8244 0.336097H7.1636C7.04457 0.336097 6.92384 0.33464 6.80184 0.331726C6.67992 0.328994 6.61593 0.327477 6.60999 0.327477C6.58031 0.327477 6.53856 0.328994 6.48483 0.331757C6.43125 0.334671 6.38947 0.336128 6.35975 0.336128L5.95786 0.34484L2.56479 0.457488L0.243197 0.509517L0.278914 1.22878C0.778887 1.29241 1.11835 1.33008 1.29688 1.34155C1.60047 1.35889 1.80586 1.40233 1.91304 1.47157C1.97859 1.51786 2.01431 1.55249 2.02025 1.57559C2.07974 1.70269 2.11239 2.01757 2.11846 2.52028C2.14223 3.37542 2.16909 4.54251 2.19877 6.02157L2.21663 10.3289C2.21663 11.0683 2.18989 11.6289 2.13632 12.0102C2.11251 12.1489 2.04993 12.2962 1.94875 12.4522C1.6749 12.5619 1.30882 12.6516 0.850446 12.7209C0.713615 12.7381 0.511167 12.7728 0.243322 12.825L0.225464 13.6396C1.64816 13.5933 2.45774 13.5616 2.65443 13.5442C3.92826 13.469 4.81536 13.4373 5.31536 13.4488L7.07437 13.4833C7.76516 13.5064 8.35446 13.4746 8.84251 13.3881C9.61634 13.2494 10.2204 13.0759 10.6552 12.8679C11.0956 12.66 11.5123 12.3479 11.9051 11.932C12.2031 11.6143 12.4141 11.2763 12.5391 10.9179C12.7118 10.4269 12.798 9.9619 12.798 9.52269C12.7982 8.77173 12.5244 8.08986 11.9766 7.47738ZM4.98497 1.33302C5.44929 1.25793 5.83623 1.22038 6.14577 1.22038C7.16366 1.22038 7.92285 1.43708 8.42279 1.87037C8.92849 2.3036 9.18163 2.8439 9.18163 3.49095C9.18163 4.40968 8.91682 5.05676 8.38704 5.43229C7.85727 5.80778 7.07143 5.99562 6.0297 5.99562C5.63682 5.99562 5.31239 5.97543 5.05646 5.935C5.05043 5.73851 5.04746 5.5161 5.04746 5.26761L5.05646 4.4183C5.06234 3.51129 5.04449 2.70532 5.00286 2.00032C4.99091 1.80969 4.98497 1.5874 4.98497 1.33302ZM9.44973 11.3428C9.22946 11.7587 8.86622 12.0852 8.3604 12.3222C7.85433 12.5591 7.21133 12.6774 6.43159 12.6774C6.05059 12.6774 5.63388 12.5852 5.18147 12.4003C5.11004 12.2328 5.07429 12.1055 5.07417 12.0188L5.04746 9.6788L5.05646 8.1795V6.93147C5.21722 6.87371 5.51788 6.84487 5.95836 6.84487C6.95252 6.84487 7.68763 6.93733 8.16389 7.12216C8.65796 7.30721 9.07771 7.67117 9.42299 8.21429C9.66703 8.59573 9.78904 9.11565 9.78904 9.77436C9.78892 10.4155 9.67576 10.9384 9.44973 11.3428Z"
              />
            </svg>
          </b-btn>
          <b-btn
            :class="{ 'is-active': isActive.italic() }"
            variant="white"
            class="h-[28px] w-[28px] p-0"
            @click="commands.italic"
          >
            <svg
              fill="none"
              height="14"
              viewBox="0 0 10 14"
              width="10"
              xmlns="http://www.w3.org/2000/svg"
              class="scale-75"
            >
              <path
                :fill="isActive.italic() ? '#000' : '#AEB1B4'"
                d="M5.65722 10.7081C5.68453 10.6038 5.71183 10.4968 5.73557 10.3884C5.73915 10.3708 6.15226 8.55152 6.59386 6.65231C7.3536 3.38626 7.53879 2.72926 7.58034 2.62902C7.7216 2.29577 7.95071 2.04381 8.28072 1.85822C8.56563 1.69838 8.92888 1.59271 9.36098 1.54395C9.488 1.52905 9.6079 1.44912 9.69575 1.31908C9.77528 1.20122 9.82158 1.05221 9.82158 0.909973C9.82158 0.588923 9.59247 0.327477 9.31113 0.327477H3.52402C3.24268 0.327477 3.01357 0.588923 3.01357 0.909973V0.930293C3.01357 1.21748 3.194 1.4586 3.44212 1.50466C3.77094 1.56562 4.22203 1.64961 4.5758 1.84061C4.75743 1.93815 4.89868 2.05736 4.99247 2.19282C5.09931 2.3459 5.15154 2.52335 5.15154 2.73332C5.15154 3.12617 5.05064 3.52037 4.9533 3.90103C4.93312 3.98095 4.91175 4.06494 4.89157 4.14622C4.76692 4.65421 4.58292 5.425 4.37043 6.31771C3.88016 8.3727 3.27 10.9289 3.11686 11.4152C3.01358 11.7431 2.63014 12.5193 1.31128 12.6344C1.18307 12.6453 1.06317 12.7116 0.976516 12.8187C0.88867 12.927 0.841187 13.0666 0.841187 13.2142V13.2156C0.841187 13.5366 1.0703 13.7981 1.35164 13.7981H7.13995C7.42128 13.7981 7.6504 13.5366 7.6504 13.2156V13.2115C7.6504 12.9175 7.45809 12.6696 7.20286 12.6344C7.153 12.6276 7.10433 12.6209 7.0521 12.6141C6.54402 12.5477 5.91249 12.4637 5.64658 12.0695C5.52313 11.8866 5.48395 11.6455 5.5243 11.3353C5.55038 11.1254 5.60263 10.9222 5.65722 10.7081Z"
              />
            </svg>
          </b-btn>
          <b-btn
            :class="{ 'is-active': isActive.underline() }"
            variant="white"
            class="h-[28px] w-[28px] p-0"
            @click="commands.underline"
          >
            <svg
              fill="none"
              height="16"
              viewBox="0 0 15 16"
              width="15"
              xmlns="http://www.w3.org/2000/svg"
              class="scale-75"
            >
              <path
                :fill="isActive.underline() ? '#000' : '#AEB1B4'"
                d="M0.517612 1.31839C1.27851 1.33713 1.73685 1.45882 1.89265 1.6828C1.99861 1.8389 2.05169 2.50295 2.05169 3.67535V6.79053C2.05169 7.76975 2.10149 8.50867 2.20126 9.00761C2.33861 9.74968 2.59739 10.3579 2.97779 10.8317C3.35183 11.2995 3.91011 11.6801 4.65216 11.9731C5.38184 12.2599 6.2674 12.4033 7.3088 12.4033C8.21923 12.4033 9.01447 12.3006 9.6944 12.0947C10.3615 11.8951 10.9291 11.6175 11.3967 11.2621C11.8584 10.9005 12.2076 10.5169 12.4444 10.1114C12.6065 9.82461 12.7346 9.44405 12.8281 8.97043C12.9591 8.29071 13.006 7.34243 12.9685 6.12641C12.8813 3.77515 12.8126 2.5404 12.7626 2.42189C12.7626 2.35338 12.7579 2.25669 12.7487 2.13198C12.7393 2.00718 12.7346 1.92314 12.7346 1.87943C12.7346 1.71727 12.7815 1.58933 12.875 1.49588C12.9126 1.45849 13.1587 1.40538 13.614 1.33677C13.8573 1.33055 14.1193 1.28988 14.3999 1.21518C14.425 1.06554 14.4372 0.968885 14.4372 0.925143C14.4372 0.844082 14.4188 0.685008 14.3813 0.448148L14.2129 0.42944C13.4644 0.510533 12.8533 0.541627 12.3792 0.522951L10.4617 0.42944H9.67592L9.65708 1.23402L9.78814 1.262L10.7236 1.24333C10.9916 1.2371 11.2318 1.34316 11.4438 1.56148C11.5622 1.69244 11.6372 1.96675 11.6683 2.3846L11.7055 2.93666C11.7432 3.47296 11.7852 3.97024 11.832 4.42856C11.8789 4.88694 11.9132 5.26895 11.935 5.57445C11.9567 5.88012 11.9677 6.27923 11.9677 6.77192C11.9677 7.74485 11.9022 8.45867 11.7712 8.91391C11.6654 9.27563 11.4999 9.6313 11.2756 9.98048C11.1693 10.1551 10.9667 10.3547 10.6673 10.5793C10.3993 10.785 10.0907 10.944 9.74132 11.0562C9.19864 11.2309 8.60314 11.3181 7.95469 11.3181C7.39946 11.3181 6.8478 11.1717 6.29892 10.8784C5.91852 10.6727 5.61922 10.3859 5.40094 10.0179C5.12037 9.53159 4.9613 8.90146 4.92385 8.1281L4.79289 5.50892L4.78335 3.36693C4.78335 3.32965 4.78175 3.25009 4.77864 3.1285C4.77549 3.00691 4.77392 2.90576 4.77392 2.82457C4.77392 2.0887 4.81445 1.67717 4.89548 1.58982C5.01412 1.43385 5.26038 1.35591 5.63455 1.35591C6.03379 1.35591 6.42038 1.32789 6.79455 1.27177V1.18756L6.77588 0.588907L6.78515 0.45788C6.59813 0.47033 6.33002 0.476621 5.98074 0.476621C5.79372 0.482847 5.33839 0.498443 4.61498 0.523377C4.10345 0.542119 3.57964 0.551359 3.04335 0.551359C2.83126 0.551359 2.31368 0.529668 1.49046 0.485927C1.16619 0.461025 0.816918 0.448607 0.442744 0.448607C0.274333 0.448607 0.149598 0.451622 0.0686035 0.457912L0.0966829 1.28117C0.146518 1.29349 0.28685 1.30601 0.517612 1.31839Z"
              />
              <path
                :fill="isActive.underline() ? '#000' : '#AEB1B4'"
                d="M14.138 13.9998H0.367917C0.28063 13.9998 0.208873 14.0395 0.152746 14.1191C0.0965526 14.1987 0.0686035 14.3002 0.0686035 14.4239V15.2721C0.0686035 15.3959 0.0966836 15.4975 0.152746 15.577C0.208873 15.6566 0.280499 15.6961 0.367917 15.6961H14.138C14.2254 15.6961 14.2972 15.6565 14.3533 15.577C14.4093 15.4975 14.4372 15.3959 14.4372 15.2721V14.4239C14.4372 14.3002 14.4093 14.1986 14.3533 14.1191C14.2972 14.0395 14.2254 13.9998 14.138 13.9998Z"
              />
            </svg>
          </b-btn>
          <b-btn
            :class="{ 'is-active': isActive.strike() }"
            variant="white"
            class="h-[28px] w-[28px] p-0"
            @click="commands.strike"
          >
            <i
              :class="isActive.strike() ? 'text-dark' : 'text-[#AEB1B4]'"
              class="fa fa-strikethrough text-[12px]"
            />
          </b-btn>
          <b-btn
            :class="{ 'is-active': isActive.link() }"
            variant="white"
            class="h-[28px] w-[28px] p-0"
            @click="toggleLinkMenu(getMarkAttrs('link'))"
          >
            <svg
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.14551 8.4259L7.92566 4.64575"
                stroke="#717171"
                stroke-width="1.33649"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.72793 6.06323L1.78289 7.00827C0.739035 8.05213 0.739035 9.74456 1.78289 10.7884C2.82675 11.8323 4.51919 11.8323 5.56305 10.7884L6.50808 9.84338"
                stroke="#717171"
                stroke-width="1.33649"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.56299 3.22793L6.50803 2.28289C7.55189 1.23904 9.24432 1.23904 10.2882 2.28289C11.332 3.32675 11.332 5.01919 10.2882 6.06305L9.34314 7.00808"
                stroke="#717171"
                stroke-width="1.33649"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </b-btn>
        </b-btn-group>

        <div class="my-3">
          <form
            v-if="linkMenuIsActive"
            @submit.prevent="setLinkUrl(commands.link, linkUrl)"
          >
            <div class="flex gap-2 mb-2">
              <b-input
                ref="linkInput"
                v-model="linkUrl"
                type="text"
                placeholder="https://"
                @keydown.esc="hideLinkMenu"
              />

              <div class="flex gap-2">
                <b-btn
                  variant="white"
                  class="h-[28px] w-[28px] text-[10px] p-0"
                  type="submit"
                >
                  <i class="fa fa-check" />
                </b-btn>

                <b-btn
                  variant="white"
                  class="h-[28px] w-[28px] text-[10px] p-0"
                  @click="() => setLinkUrl(commands.link, null)"
                >
                  <i class="fa fa-trash" />
                </b-btn>
              </div>
            </div>

            <pages-select-menu
              :others="[{id: 'custom-link', title: 'Custom Link'}]"
              input-class="rounded-[4px]"
              other-title="Other:"
              @selectPage="item => onSelectPage(item)"
            >
              <template
                v-if="page"
                slot="placeholder"
              >
                <div class="px-3">
                  {{ page.page }}
                </div>
              </template>
            </pages-select-menu>
          </form>
        </div>
      </div>
    </editor-menu-bar>
  </div>
</template>

<script>
import { Editor } from '@tiptap/core'
import { EditorContent } from '@tiptap/vue-2'

import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Link from '@tiptap/extension-link'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Strike from '@tiptap/extension-strike'
import Underline from '@tiptap/extension-underline'
import PagesSelectMenu from '@/components/editor/components/pagesSelectMenu/PagesSelectMenu.vue'
import {mapState} from 'vuex'

const EditorMenuBar = {
  name: 'EditorMenuBar',
  props: {
    editor: {
      type: Object,
      required: true
    }
  },
  render () {
    const editor = this.editor

    if (!editor) {
      return null
    }

    const commands = {
      bold: () => editor.chain().focus().toggleBold().run(),
      italic: () => editor.chain().focus().toggleItalic().run(),
      underline: () => editor.chain().focus().toggleUnderline().run(),
      strike: () => editor.chain().focus().toggleStrike().run(),
      link: attrs => {
        // если attrs или href нет — снимаем ссылку
        if (!attrs || !attrs.href) {
          return editor.chain().focus().extendMarkRange('link').unsetLink().run()
        }

        return editor.chain().focus().extendMarkRange('link').setLink(attrs).run()
      }
    }

    const isActive = new Proxy({}, {
      get (_, key) {
        return (attrs) => editor.isActive(key, attrs)
      }
    })

    const getMarkAttrs = (name) => {
      try {
        return editor.getAttributes(name) || {}
      } catch (e) {
        return {}
      }
    }

    const slot = this.$scopedSlots.default

    if (!slot) {
      return null
    }

    const children = slot({
      editor,
      commands,
      isActive,
      getMarkAttrs
    })

    return Array.isArray(children) ? children[0] : children
  }
}

export default {
  name: 'TiptapV2',

  components: {
    PagesSelectMenu,
    EditorContent,
    EditorMenuBar
  },

  props: {
    value: {
      required: true
    },
    customs: {},
    section: {},
    uid: String,
    type: {
      type: String,
      default: 'paragraph'
    },
    customClass: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      page: null,
      editor: null,
      linkUrl: null,
      linkMenuIsActive: false
    }
  },

  created () {
    this.editor = new Editor({
      extensions: [
        Document,
        Paragraph,
        Text,
        Link.configure({
          openOnClick: false
        }),
        Bold,
        Italic,
        Strike,
        Underline
      ],
      content: this.value,
      onUpdate: ({ editor }) => {
        const content = editor.getHTML()
        this.$emit('input', content)
      },
      parseOptions: {
        preserveWhitespace: 'full'
      }
    })
  },

  computed: {
    ...mapState('projects', {
      project: state => state.project
    })
  },

  beforeDestroy () {
    if (this.editor) {
      this.editor.destroy()
    }
  },

  methods: {
    onSelectPage (item) {
      this.linkUrl = `https://${(this.project.domain || this.project.subdomain + '.estage.site')}/${item.slug}`
    },

    toggleLinkMenu (attrs) {
      if (this.linkMenuIsActive) return this.hideLinkMenu()

      this.linkUrl = attrs.href
      this.linkMenuIsActive = true
      this.$nextTick(() => {
        this.$refs.linkInput.focus()
      })
    },
    hideLinkMenu () {
      this.linkUrl = null
      this.linkMenuIsActive = false
    },
    setLinkUrl (command, url) {
      command({href: url, target: '_blank'})
      this.hideLinkMenu()
    }
  }
}
</script>

<style>
.tiptap-v2 .ProseMirror {
  height: 100%;
}
</style>